import paginationReducer from "./PaginationReducer";

const reducers = {
  paginationReducer,
};

export default reducers;
